__turbopack_context__.v({
  "h3": "PortableTextRichText-module-scss-module__3WPnUW__h3",
  "link": "PortableTextRichText-module-scss-module__3WPnUW__link",
  "ol": "PortableTextRichText-module-scss-module__3WPnUW__ol",
  "ul": "PortableTextRichText-module-scss-module__3WPnUW__ul",
});
